import React from 'react';
import { Icon, Button, Switch } from 'components';
import classNames from 'lib/classNames';

const Alert = ({
	type = 'info',
	title,
	children,
	icon = null,
	desc = null,
	withSwitch = null,
	actions = [],
	style = {},
	forwardRef = null,
	borderPosition = 'border-l-4',
	paddingX = 'px-2',
	className = '',
	customStyle = {},
	inlineIcon,
	iconSize,
	closable,
}) => {
	const styles = {
		info: {
			box: 'border-l-4 border-blue-500 bg-white text-gray-500 text-md',
			title: 'text-gray-600',
			icon: 'text-blue-500',
		},
		error: {
			box: 'border-l-4 border-red-500 bg-white text-gray-500 text-md',
			title: 'text-red-500',
			icon: 'text-gray-600',
		},
		warning: {
			box: 'border-orange-400 bg-white text-gray-800 bg-yellow-100 ' + borderPosition,
			title: 'text-gray-900',
			icon: 'text-orange-400',
			inlineIcon: !!inlineIcon,
			iconSize: iconSize,
		},
		warning_secondary: {
			box: 'bg-yellow-200 border-b-2 border-yellow-300 text-yellow-800 rounded text-justify',
			title: 'font-semibold text-yellow-800 mb-2 uppercase text-left',
			icon: 'bg-white text-yellow-500 rounded-full w-10 h-10  flex-center border-2 border-yellow-500',
			iconSize: '1x',
			inlineIcon: true,
		},
		success: {
			box: 'border-l-4 border-green-400 bg-white text-gray-500',
			title: 'text-gray-600 mb-2',
			icon: 'text-green-400',
		},
		save_settings: {
			box: 'bg-white h-full max-h-full',
			title: 'text-blue-500 uppercase',
		},
	};
	return (
		<div
			className={classNames(
				className,
				(customStyle.box ? customStyle : styles[type]).box,
				'relative flex items-center text-sm py-2  rounded-lg',
				paddingX
			)}
			ref={forwardRef}
			style={style}
		>
			{icon && !styles[type].inlineIcon && (
				<div
					className={classNames(
						(customStyle.icon ? customStyle : styles[type]).icon,
						'flex items-center justify-center ml-2 mr-4'
					)}
				>
					<Icon size={styles[type].iconSize || '2x'} icon={icon} />
				</div>
			)}
			<div className={classNames('flex-1 flex-grow')}>
				{!!title && (
					<h4
						className={classNames(
							(customStyle.title ? customStyle : styles[type]).title,
							'font-semibold text-base uppercase-first',
							{
								'flex items-center': styles[type].inlineIcon,
								'mb-2': !!children
							}
						)}
					>
						{!!styles[type].inlineIcon && (
							<div
								className={classNames(
									(customStyle || styles[type]).icon,
									'flex items-center justify-center mr-2'
								)}
							>
								<Icon size={styles[type].iconSize || '2x'} icon={icon} />
							</div>
						)}
						<div className={classNames('flex-1')}>{title}</div>
					</h4>
				)}
				{!!children && children}
			</div>
			{!!actions.length && (
				<div className={classNames('pl-2')}>
					{actions.map((action, i) => (
						<Button
							className={classNames({ 'mr-2': i !== actions.length - 1 })}
							key={i}
							type={action.type || type}
							{...action}
						/>
					))}
				</div>
			)}
			{!!withSwitch && (
				<Switch
					className={classNames('pl-2')}
					BindToContext={withSwitch.context}
					{...(withSwitch.props || {})}
				/>
			)}
		</div>
	);
};

export default Alert;
